'use client';

import React, { useState } from 'react';
import { Product } from '../types/type';
import ProductCard from '@/features/product-card/components/productCard';
import data from '../../../../../public/json/popular-product.json';

const FlashSaleProduct = () => {
  const [product, setProduct] = useState(data);

  return (
    <section className="product padding-top padding-bottom ">
      <div className="container">
        <div className="product__wrapper">
          <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 justify-content-center g-3">
            {product?.length > 0 ? (
              product.map((data: Product, i: number) => (
                <div className="col" key={i}>
                  <ProductCard data={data} />
                </div>
              ))
            ) : (
              <p className="text-center">No products available.</p>
            )}
          </div>
          <div className="product-btn text-center mt-5">
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setProduct([...product, ...data]);
              }}
              className="about__btn trk-btn trk-btn--primary"
            >
              View More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlashSaleProduct;
